import React, {ChangeEvent, KeyboardEvent} from 'react';
import { TextField, Button } from '@material-ui/core';
import { Link, withRouter} from 'react-router-dom';
import Auth from '@aws-amplify/auth';
import {  withTranslation, WithTranslation, Trans} from 'react-i18next';


interface State {
    user : any;
    email: string;
    password:string;
    err:string;
}


class SignIn extends React.Component<any,State>
{

    onChange = (field:string) => (ev : ChangeEvent<HTMLInputElement>) => {
        var o = {} as any; 
        o[field] = ev.target.value;
        this.setState(o);
    }

    onSignin = (ev : any) => {
        Auth.signIn(this.state.email, this.state.password).then(data => {
        this.setState({err:"", user:data});
        }).catch(err=>{this.setState({err: err.message});});
    }
    onSignOut = (ev : any) => {
        Auth.signOut().then(data=>{
            this.setState({user:null});
        });
    }
    gotoMyCourses = (ev:any) => {
        this.props.history.push('/myEvents');
    }

    onKeyPress = (ev: KeyboardEvent) => {
        if (ev.keyCode == 13)
        {
            this.onSignin(null);
        }
    }


    constructor(props : any) {
        super(props);
        this.state={user: null, email:"",password:"",err:""};
        Auth.currentAuthenticatedUser({
            bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
        }).then(user => {
            this.setState({user: user});
        }).catch(err => {});
    }

    render() {
        let {t} = this.props;
        return this.state.user ? <div><b>{t('LOGGED_IN_AS')}: {this.state.user.username}</b><br/>
                    <Button style={{margin:'2px'}}  variant="contained" color="primary" onClick={this.gotoMyCourses}>{t('MY_COURSES')}</Button>
                    <Button style={{margin:'2px'}} variant="contained" color="primary" onClick={this.onSignOut}>{t('LOGOUT')}</Button></div> :
             <div><TextField label={t('EMAIL')} onChange={this.onChange("email")} /><br/>
        <TextField type="password" label={t('PASSWORD')} onChange={this.onChange("password")} onKeyDown={this.onKeyPress} /><br/>
        <p><Button variant="contained" color="primary" onClick={this.onSignin}>{t('LOGIN')}</Button></p>
        {this.state.err && 
            <span style={{color:'red'}}>{this.state.err}</span>
        }
        <p><Trans i18nKey='CREATE_ACCOUNT_INFO'><Link to="/signup"></Link></Trans></p></div>;
    }
}
export default withRouter(withTranslation()(SignIn) as any);